import { useEffect } from 'react';
import { Routes, Route, useParams } from 'react-router';
import DelsystemOversikt from '../../../Features/Delsystem/_DelsystemOversikt/DelsystemOversikt';
import { IDelsystem } from '../../../Features/Delsystem/_Common/Const/Delsystem';
import { rapportRouteName, styrvardeRouteName } from '../router';
import { setPageTitle } from '../../../Utils/analyticsUtils';

interface IProps {
  delsystem: IDelsystem;
  dbName?: string;
}

const RapportRoute = (props: { dbName?: string; delsystem: IDelsystem }) => {
  const { rapportID } = useParams<{ rapportID: string }>();
  return (
    <DelsystemOversikt
      dbName={props.dbName}
      delsystem={props.delsystem}
      tab={2}
      rapportID={rapportID}
    />
  );
};

const DelsystemRouter = (props: IProps) => {
  useEffect(() => {
    setPageTitle(
      props.delsystem.benamning || '-',
      `Delsystem ${props.delsystem.benamning}`
    );
  }, [props.delsystem]);

  return (
    <Routes>
      <Route
        path={styrvardeRouteName}
        element={
          <DelsystemOversikt
            dbName={props.dbName}
            delsystem={props.delsystem}
            tab={1}
          />
        }
      />
      <Route
        path={`${rapportRouteName}/:rapportID`}
        element={
          <RapportRoute dbName={props.dbName} delsystem={props.delsystem} />
        }
      />
      <Route
        path={rapportRouteName}
        element={
          <DelsystemOversikt
            dbName={props.dbName}
            delsystem={props.delsystem}
            tab={2}
          />
        }
      />
      <Route
        path="*"
        element={
          <DelsystemOversikt
            dbName={props.dbName}
            delsystem={props.delsystem}
          />
        }
      />
    </Routes>
  );
};

export default DelsystemRouter;
